import axios, { AxiosResponse } from "axios";
import { UploadLink } from "@/__generated__/graphql";

export async function uploadFiles(
  files: File[],
  uploadUrls: UploadLink[],
): Promise<AxiosResponse[]> {
  return Promise.all(
    uploadUrls.map((uploadLink) => {
      let file: undefined | File;
      for (let i = 0; i < files.length; i += 1) {
        if (files[i].name.includes(uploadLink.fileExtension)) {
          file = files[i];
          files.splice(i, 1);
          break;
        }
      }

      if (file !== undefined) {
        return axios({
          method: "PUT",
          url: uploadLink.uploadUrl,
          data: file,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      return Promise.reject(new Error("Upload file does not exist"));
    }),
  );
}
